/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type withWidgetData_widget = {|
  +id: string;
  +config: ?{|
    +filterComments: ?boolean;
    +sliceByQuestion: ?string;
    +aggregateQuestions: ?$ReadOnlyArray<?string>;
    +ignoreDateFilter: ?boolean;
    +showLastXMonths: ?number;
    +commentExtraColumns: ?$ReadOnlyArray<?{|
      +title: ?string;
      +questionId: ?string;
    |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "withWidgetData_widget",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "WidgetConfig",
      "name": "config",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "filterComments",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "sliceByQuestion",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "aggregateQuestions",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "ignoreDateFilter",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "showLastXMonths",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "commentExtraColumn",
          "name": "commentExtraColumns",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "title",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "questionId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "WidgetMenu_widget",
      "args": null
    }
  ],
  "type": "Widget"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/withWidgetData/__generated__/withWidgetData_widget.graphql.js